<template>
  <div class="seekBarWrapper">
    <div class="seekBar">
      <div class="fillArea" :style="`width: ${progress}%`"></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    progress() {
      return this.$store.getters.getSeekBarUserJourney
    },
  },
}
</script>

<style scoped>
.seekBarWrapper {
  width: 100%;
  padding: 18px 20px 16px;
}

.seekBar {
  width: 100%;
  height: 8px;
  background: #EAF0F6;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
}

.fillArea {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 20px;
  background: #39C990;
  transition: width 0.3s ease;
}

@media (min-width: 960px) {
  .seekBarWrapper {
    padding: 0 0 20px;
  }

  .seekBar {
    height: 10px;
  }
}
</style>
